import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CampaignVideoService } from '../../services/campaign-video.service';
import { CampaignVideo } from '../../models/campaignVideo';

@Component({
  selector: 'app-public-campaign-analytics',
  imports: [CommonModule],
  templateUrl: './public-campaign-analytics.component.html',
  styleUrl: './public-campaign-analytics.component.css'
})
export class PublicCampaignAnalyticsComponent implements OnInit {
  campaignId: string = '';
  videos: CampaignVideo[] = [];
  loading: boolean = true;
  error: string = '';

  constructor(private route: ActivatedRoute, private campaignVideoService: CampaignVideoService) {}

  ngOnInit(): void {
    this.campaignId = this.route.snapshot.paramMap.get('campaignId') || '';
    if (!this.campaignId) {
      this.error = 'No campaign specified.';
      this.loading = false;
      return;
    }

    this.campaignVideoService.getPublicVideos(this.campaignId).subscribe({
      next: (videos) => {
        this.videos = videos;
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load public videos', err);
        this.error = 'Could not load analytics for this campaign.';
        this.loading = false;
      }
    });
  }

  get latestRefresh(): string | null {
    const stamps = this.videos
      .map(v => v.lastRefresh)
      .filter((s): s is string => !!s);
    if (stamps.length === 0) return null;
    return stamps.sort().slice(-1)[0];
  }
}
